<template>
  <div class="error-submit-wrapper">
    <div class="error-bg">
      <img class="error-bg-img" src="@/assets/error_dialog_head.png" alt="" />
      <div class="error-content">
        <div class="error-title">选择你要反馈的问题</div>
        <div class="error-list">
          <span
            v-for="item in errorMap"
            :key="item.value"
            :class="['error-list-item', active.includes(item.value) && 'error-list-item-active']"
            @click="changeActive(item.value)"
            >{{ item.label }}</span
          >
        </div>
        <div class="error-text" :data-text="remark.length + '/100'">
          <textarea
            v-model="remark"
            class="error-textarea"
            maxlength="100"
            placeholder="请输入备注"
          ></textarea>
        </div>
        <div class="error-title">添加图片</div>
        <div class="flex-row flex-wrap mb-3 mt-3">
          <div v-for="(i, idx) in fileList" :key="idx" class="file-list">
            <img class="file-list-img" :src="i.fileUrl" @click="openImage(i.fileUrl)" />
            <i class="file-delete" @click="deleteCurrentImage(i.atmId)"></i>
          </div>
          <input
            id="file-input"
            :value="fileValue"
            class="file-input"
            type="file"
            accept=".jpg,.jpeg,.png,.webp,.svg,.bmp"
            @change="handleFileInputChange"
          />
          <label for="file-input" class="file-input-label"></label>
        </div>
        <div class="error-btn-group">
          <ion-button class="error-btn error-btn__cancel" @click="cancel">取消</ion-button>
          <ion-button class="error-btn error-btn__confirm" @click="confirm">提交</ion-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { IonButton, modalController } from "@ionic/vue"
import {
  computed,
  defineExpose,
  defineProps,
  getCurrentInstance,
  onMounted,
  ref,
  withDefaults,
} from "vue"
import myAjax from "@/js/http"
import http from "@/js/http"
import AttachmentImage from "@/views/personal/AttachmentImage.vue"
import { useStorage } from "@vueuse/core"
import mqttServer from "@/js/mqtt"

interface FileObjType {
  atmId: number | string
  fileUrl: any
}

interface CommonType {
  label: string
  value: number
}

interface WordObjType {
  vocabularyId?: number
  courseId?: number
  word?: string
  paraphrase?: string
  suggestionType?: number
  description?: string
}

const props = withDefaults(
  defineProps<{
    wordObj: WordObjType
  }>(),
  {
    wordObj: () => ({}),
  }
)
const userInfo = useStorage("userinfo", {})

const instance = getCurrentInstance() as any
const wordObj = computed(() => props.wordObj)
const errorMap: CommonType[] = [
  {
    label: "发音不标准",
    value: 1,
  },
  {
    label: "释义错误",
    value: 2,
  },
  {
    label: "没有发音",
    value: 3,
  },
  {
    label: "拼写错误",
    value: 4,
  },
]
const active = ref<number[]>([])
const remark = ref("")
const fileList = ref<FileObjType[]>([])
const fileValue = ref<any>()

const publish = ref<any>({
  topic: "10/browser",
  qos: 0,
  payload: '{ "msg": "Hello, I am browser." }',
})

const instructData = ref<any>({
  project: "lxll",
  page: "teachIndex",
  module: "ErrorSubmitDialog",
  userType: 1,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
})

onMounted(() => {
  mqttServer.onMqttMessage(instructData.value.module, onMessageReceived)
})
defineExpose({
  changeActive,
  handleRemark,
  openMsgToast,
  confirm,
  cancelSync,
})

function handleRemark(str: any) {
  remark.value = str
}

function remarkChange(e: any, synchronous: any) {
  console.log(e)
  if (synchronous == undefined) {
    // mqttServer.pushMsg(instructData.value, { fn: 'onFiveClose', msgType: 'function' })
    mqttServer.pushMsg(instructData.value, {
      params: e.target.value,
      fn: "handleRemark",
      msgType: "function",
    })
  }
}

async function onMessageReceived(msg: any) {
  console.log(msg)
  if (Array.isArray(msg.params)) {
    instance?.exposed[msg.fn](...msg.params)
  } else {
    instance?.exposed[msg.fn](msg.params)
    // this[msg.fn](msg.params)
  }
}

function instructMeth(instruct: any, msg: any, params: any, fn: any) {
  const obj = {
    ...instructData.value,
  }
  obj.data = instruct
  obj.params = params
  obj.msg = msg
  obj.fn = fn
  obj.type = userInfo.value.userType
  publish.value.payload = JSON.stringify(obj)
}

function changeActive(activeValue: number, synchronous: any) {
  if (synchronous == undefined) {
    mqttServer.pushMsg(instructData.value, {
      params: [activeValue, undefined],
      fn: "changeActive",
      msgType: "function",
    })

    // instructMeth('', '', [activeValue], 'changeActive')
    // doPublish(publish.value)
  }

  if (active.value.includes(activeValue)) {
    active.value = active.value.filter((i) => i !== activeValue)
  } else {
    active.value.push(activeValue)
  }
}

function handleAtmIds() {
  const arr = []
  for (let i of fileList.value) {
    arr.push(i.atmId)
  }
  return arr.join(",")
}

async function confirm(synchronous: any) {
  if (remark.value.length > 100) {
    if (synchronous == undefined) {
      mqttServer.pushMsg(instructData.value, {
        params: "超出文字100的长度限制，请重新输入",
        fn: "openMsgToast",
        msgType: "function",
      })
    }

    return openMsgToast("超出文字100的长度限制，请重新输入")
  }
  if (active.value.length > 0) {
    const res = await myAjax.post("/suggestion/saveSuggestion", {
      vocabularyId: wordObj.value.vocabularyId,
      courseId: instance.appContext.config.globalProperties.store.getAppointment().courseId,
      word: wordObj.value.word,
      paraphrase: wordObj.value.paraphrase,
      description: remark.value,
      suggestionType: active.value.join(";"),
      atmIds: handleAtmIds(),
    })

    if (res.data.code === 200) {
      mqttServer
        .pushMsg(instructData.value, {
          params: "提交成功，谢谢您的反馈！",
          fn: "openMsgToast",
          msgType: "function",
        })
        .then(() => {
          openMsgToast("提交成功，谢谢您的反馈！")
          mqttServer
            .pushMsg(instructData.value, {
              params: "",
              fn: "cancelSync",
              msgType: "function",
            })
            .then(() => {
              modalController.dismiss("cancel")
            })
        })

      // instructMeth('', '', i18n.global.t('提交成功，谢谢您的反馈！'), 'openMsgToast')
      // doPublish(publish.value)
      // await modalController.dismiss("cancel")
    } else {
      openMsgToast(res.data.message)
    }
  } else {
    mqttServer.pushMsg(instructData.value, {
      params: "请选择你要反馈的问题",
      fn: "openMsgToast",
      msgType: "function",
    })

    // instructMeth('', '', i18n.global.t('请选择你要反馈的问题'), 'openMsgToast')
    // doPublish(publish.value)
    openMsgToast("请选择你要反馈的问题")
  }
}

async function cancel() {
  mqttServer
    .pushMsg(instructData.value, {
      params: "",
      fn: "cancelSync",
      msgType: "function",
    })
    .then(() => {
      modalController.dismiss("cancel")
    })
}

function cancelSync() {
  modalController.dismiss("cancel")
}

async function openImage(imageUrl: string) {
  const modal = await modalController.create({
    component: AttachmentImage,
    componentProps: { imageUrl: imageUrl },
    cssClass: "modal_controller_class",
  })
  return modal.present()
}

function handleFileInputChange(e: any) {
  if (fileList.value.length >= 3) {
    openMsgToast("最多上传3张图片")
    return
  }

  const file = e.target.files[0]

  if (!file) {
    return
  }

  if (!/image\/+/g.test(file.type)) {
    // 其他格式文件
    openMsgToast("请上传图片文件!")
    return
  }
  if (file) {
    uploadFileToOss(file)
  }
}

// function uploadFormData(label: string, compressionFile: any) {
//   const form = new FormData();
//   const dataTimestamp = new Date().getTime() * 10 ** 4 * Math.random();
//   form.append("label", label);
//   form.append("dataTimestamp", dataTimestamp + "");
//   form.append("file", compressionFile);
//   form.append("fileType", "1");
//
//   myAjax.post("/attachment/uploadAttachment", form).then((res) => {
//     if (res.data.success) {
//       const fileUrl = URL.createObjectURL(compressionFile);
//       fileList.value.push({ atmId: res.data.data.atmId, fileUrl: fileUrl });
//       fileValue.value = ""; // 清空上传文件value值，为了避免第二次上传同样文件无法出发change事件
//     } else {
//       openMsgToast(res.data.error);
//     }
//   });
// }

async function uploadFileToOss(file: any) {
  if (file) {
    const formData = new FormData()
    formData.append("file", file)
    const res = await http.post("/attachment/uploadImageOss", formData, undefined, undefined, {
      ossFileUrl: "edu_suggestion_v3",
      label: "EDU_SUGGESTION",
    })
    if (res.data.code === 200) {
      const fileUrl = URL.createObjectURL(file)
      fileList.value.push({ atmId: res.data.data, fileUrl: fileUrl })
      fileValue.value = "" // 清空上传文件value值，为了避免第二次上传同样文件无法出发change事件
      return res.data.data
    } else {
      await openMsgToast(res.data.error ?? "上传oss错误")
      return undefined
    }
  } else {
    return undefined
  }
}

function deleteCurrentImage(atmId: number | string) {
  fileList.value = fileList.value.filter((i) => i.atmId !== atmId)
}
</script>

<style scoped lang="less">
@import "@/styles/variables.less";

.error-text {
  display: flex;
  position: relative;

  &::after {
    content: attr(data-text);
    position: absolute;
    bottom: 1.2rem;
    right: 0.3rem;
    font-size: 0.7rem;
    color: #868f9e;
  }
}

.error-textarea {
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: none;
  height: 6rem;
  width: 100%;
  background: #f5f5f5;
  padding: 0.5rem;
  font-size: 0.8rem;
  resize: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }
}

.error-submit-wrapper {
  background: #fff;
  width: 22.5rem;
  height: 70vh;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1rem;
}

.error-bg {
  position: absolute;
  width: 100%;
  height: 100%;

  .error-bg-img {
    position: absolute;
    top: -6rem;
    width: 100%;
  }

  .error-content {
    margin-top: 5rem;
    padding: 0.5rem;

    .error-title {
      color: #262626;
      font-size: 0.8rem;
      font-weight: 600;
    }

    .error-list {
      display: flex;
      flex-wrap: wrap;
      margin: 1rem 0 0.5rem;
      font-size: 0.6rem;

      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.8rem;
        margin-bottom: 0.5rem;
        padding: 0.5rem 1.2rem;
        border: 1px solid #ededed;
        border-radius: 2rem;
        letter-spacing: 0.1rem;

        &-active {
          border: 1px solid #2bca9c;
          background-color: #caf1e8;
          color: #2bca9c;
        }
      }
    }
  }

  .error-textarea {
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    border: none;
    height: 4rem;
    width: 100%;
    background: #f5f5f5;
    padding: 0.5rem;
    font-size: 0.6rem;
    resize: none;

    &:focus,
    &:focus-visible {
      outline: none;
    }
  }

  .file-list {
    width: 5rem;
    height: 5rem;
    border: 1px dotted #cecdd1;
    border-radius: 5px;
    object-fit: cover;
    position: relative;
    display: flex;
    justify-items: center;
    cursor: pointer;
    margin-right: 0.7rem;

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .file-delete {
      position: absolute;
      right: -0.5rem;
      top: -0.5rem;
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.6rem;
      padding: 0.3rem;
      border: 4px solid transparent;
      background-color: rgba(0, 0, 0, 0.7);
      background-image: url("@{base-url}speed/file_delete.svg");
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  .file-input {
    &[type="file" i] {
      display: none;
      overflow: visible;
    }
  }

  .file-input-label {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 5rem;
    height: 5rem;
    border: 1px dotted #cecdd1;
    border-radius: 5px;

    &::before {
      content: "";
      display: inline-block;
      background-image: url("@{base-url}speed/camera_icon.svg");
      background-repeat: no-repeat;
      background-size: cover;
      width: 50%;
      height: 50%;
    }

    &::after {
      content: "添加图片";
      display: block;
      color: #97989c;
      font-size: 0.8rem;
    }
  }

  .error-btn-group {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .error-btn {
      height: 2rem;
      flex: 1;
      margin: 0 0.5rem;
      font-size: 0.8rem;
      font-weight: 500;

      &::part(native) {
        border-radius: 2rem;
        box-shadow: none;
      }

      &__confirm {
        &::part(native) {
          background-color: #2bca9c;
          color: #fff;
        }
      }

      &__cancel {
        &::part(native) {
          background: #fff;
          color: #2bca9c;
          border: 1px solid #2bca9c;
        }
      }
    }
  }
}
</style>
